import { React, useState, useEffect, useRef, useMemo } from 'react'
import NavBar from '../../Navbar/Navbar'
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Link, useLocation } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { IconButton, Toolbar, Typography } from '@mui/material';
import Breadcrumb from '../../Breadcrumb/Breadcrumb'
import getCookie, { setAdminCookie } from "../../../Atom";
import CanvasJSReact from '../../../../assets/js/canvasjs-commercial-3.4/canvasjs.react'
import { getFileDetails, getGraphDetails } from "../api";
import CircularProgress from "@mui/material/CircularProgress";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CanvasJSCSVExport from '../../../../assets/js/canvasjs-commercial-3.4/CanvasJSCSVExport';
export default function FileDetail() {
    var CanvasJSChart = CanvasJSReact.CanvasJSChart;
    const [deviceInfo, setDeviceInfo] = useState({});
    const [acceleration, setAcceleration] = useState([])
    const [loading, setLoading] = useState(false);
    const [height, setHeight] = useState([]);
    const [hGAcc, setHGAcc] = useState([]);
    const [csvDataFile, setCsvDataFile] = useState([]);
    const location = useLocation();
    const [graphs, setGraphs] = useState('acc');
    const [accx, setAccx] = useState([]);
    const [accy, setAccy] = useState([]);
    const [accz, setAccz] = useState([]);
    const [hgx, setHgx] = useState([]);
    const [hgy, setHgy] = useState([]);
    const [hgz, setHgz] = useState([]);
    const [press, setPress] = useState([]);
    const chartRef = useRef(null);
    const [visibleDatasets, setVisibleDatasets] = useState({
        x: false,
        y: false,
        z: false,
    });

    const [visibleGraphs, setVisibleGraphs] = useState({
        acc: true,
        height: false,
        hGAcc: false,
    });
    const [subVisibleGraphs, setSubVisibleGraphs] = useState({
        acc: true,
        height: false,
        hGAcc: false,
    });
    const handleChange = (e) => {
        const v = e.target.value
        setGraphs(v);
        setVisibleGraphs({
            acc: v === 'acc' ? true : false,
            height: v === 'alti' ? true : false,
            hGAcc: v === 'highGAcc' ? true : false,
        })
        setVisibleDatasets({
            x: false,
            y: false,
            z: false
        })
        setSubVisibleGraphs({
            acc: v === 'acc' ? true : false,
            height: v === 'alti' ? true : false,
            hGAcc: v === 'highGAcc' ? true : false,
        })
    };
    const data = location?.state;
    const breadcrumbs = [
        <Link
            underline="hover"
            key="1"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8

            }}
            to={`/launchtrakfiles`}
        >
            <ArrowBackOutlinedIcon style={{ color: '#000000' }} />
            <Typography style={{ color: '#00000080' }}> LaunchTrak Files</Typography>

        </Link>,
        <Typography key="2" variant='h1' color="#252926" style={{ fontWeight: 500, fontSize: 21, fontFamily: 'Inter' }}>
            {data?.fileName}
        </Typography>,
    ];
    function formatValueWithUnit(value) {
        if (!value) return '--';

        const numericValue = parseFloat(value);
        const unitMatch = value.match(/\(([^)]+)\)/);

        const formattedValue = isNaN(numericValue) ? '--' : numericValue.toFixed(2);
        const unit = unitMatch ? unitMatch[0] : '';

        return `${formattedValue} ${unit}`;
    }
    const logoutHandler = async () => {
        setTimeout(() => {
            // setmyUser({
            //   fName: null,
            //   userId: null,
            //   token: null,
            //   lName: null,
            // })
            setAdminCookie({
                fName: null,
                lName: null,
                token: null,
                userId: null
            })
            let hostname = window.location.host;
            window.location.assign(`${window.location.protocol}//${hostname}/super-admin`)
        })
    }
    const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
        // setSnackBarShow(snackShow);
        // setSnackBarSeverity(snackSeverity);
        // setSnackBarMessage(snackMessage)
    }
    const convertArrayToCSV = (arrayOfObjects) => {
        if (!arrayOfObjects || !arrayOfObjects.length) {
            return '';
        }

        // Mapping for header replacements
        const headerReplacements = {
            time: 'Time(us)',
            roll: 'Roll(deg)',
            pitch: 'Pitch(deg)',
            yaw: 'Yaw(deg)',
            ax: 'AccX(m/s/s)',
            ay: 'AccY(m/s/s)',
            az: 'AccZ(m/s/s)',
            press: 'Press(Pa)',
            temp: 'Temp(C)',
            hgx: 'HGX(g)',
            hgy: 'HGY(g)',
            hgz: 'HGZ(g)'
        };

        // Headers to exclude
        const excludeHeaders = ['acc', 'vel', 'altitude', 'highGAcceleration'];

        // Extract headers, apply replacements, and exclude unwanted headers
        const headers = Object.keys(arrayOfObjects[0])
            .filter(header => !excludeHeaders.includes(header))
            .map(header => headerReplacements[header] || header); // Use replacement if available

        // Generate CSV rows
        const rows = arrayOfObjects.map(obj =>
            headers
                .map(headerKey => {
                    // Get the original key from headerReplacements or use the header itself
                    const originalKey = Object.keys(headerReplacements).find(key => headerReplacements[key] === headerKey) || headerKey;
                    return `"${obj[originalKey] ?? ''}"`;
                })
                .join(',')
        );

        // Combine headers and rows
        const csvData = [headers.join(','), ...rows].join('\n');
        setCsvDataFile(csvData);
    };
    const downloadCSV = () => {
        // Create a blob and a download link
        const blob = new Blob([csvDataFile], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${data?.fileName}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const onGetGraphDetails = async (user) => {
        setLoading(true)
        let res = await getGraphDetails(data?.id, user?.token);
        let res1 = await getFileDetails(data?.id, user?.token);
        if (res?.error || res1?.error) {
            if (res?.data?.statusCode == 401 || res1.data.statusCode == 401) {
                logoutHandler();
            } else {
                feedBackMsg(true, "error", res?.data?.msg);
            }
        } else {
            let acc = [];
            let height = [];
            let hGAcc = [];
            let ax = [];
            let ay = [];
            let az = [];
            let hgx = [];
            let hgy = [];
            let hgz = [];
            let press = [];
            const response = res?.res?.data[0]?.graphData
            for (let i = 0; i < response?.length; i++) {
                acc.push({
                    x: response[i]?.time,
                    y: response[i]?.acc
                });
                ax.push({
                    x: response[i]?.time,
                    y: response[i]?.ax
                })
                ay.push({
                    x: response[i]?.time,
                    y: response[i]?.ay
                })
                az.push({
                    x: response[i]?.time,
                    y: response[i]?.az
                })
                height.push({
                    x: response[i].time,
                    y: response[i].altitude
                })
                press.push(
                    {
                        x: response[i].time,
                        y: response[i].press
                    })
                hgx.push({
                    x: response[i]?.time,
                    y: response[i]?.hgx
                })
                hgy.push({
                    x: response[i]?.time,
                    y: response[i]?.hgy
                })
                hgz.push({
                    x: response[i]?.time,
                    y: response[i]?.hgz
                })
                hGAcc.push({
                    x: response[i].time,
                    y: response[i].highGAcceleration
                })
            }
            acc.sort((a, b) => a.x - b.x);
            setAcceleration(acc);
            height.sort((a, b) => a.x - b.x);
            setHeight(height);
            hGAcc.sort((a, b) => a.x - b.x);
            setHGAcc(hGAcc);
            setDeviceInfo(res1?.res?.data);
            ax.sort((a, b) => a.x - b.x);
            setAccx(ax);
            ay.sort((a, b) => a.x - b.x);
            setAccy(ay);
            az.sort((a, b) => a.x - b.x);
            setAccz(az);
            press.sort((a, b) => a.x - b.x);
            setPress(press);
            hgx.sort((a, b) => a.x - b.x);
            setHgx(hgx);
            hgy.sort((a, b) => a.x - b.x);
            setHgy(hgy);
            hgz.sort((a, b) => a.x - b.x);
            setHgz(hgz);
            // calling function for generate CSv
            convertArrayToCSV(response);
        }
        setLoading(false)
    };
    console.log(press, "presssssss");


    // Handle checkbox change to toggle dataset visibility
    const toggleDatasetVisibility = (key) => {
        setVisibleDatasets((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    // Chart options with dynamic visibility

    const chartOptions = useMemo(() => ({
        animationEnabled: false,
        exportEnabled: true,
        theme: "light1",
        height: 600,
        title: {
            text: (() => {
                if (visibleGraphs.acc) return "Acceleration";

                if (visibleGraphs.height) {
                    const altitudeSelected = subVisibleGraphs.height;
                    const pressureSelected = visibleDatasets.x;

                    if (altitudeSelected && pressureSelected) {
                        return "Altitude & Pressure";
                    } else if (altitudeSelected) {
                        return "Altitude";
                    } else if (pressureSelected) {
                        return "Pressure";
                    } else {
                        return "Altitude";
                    }
                }

                if (visibleGraphs.hGAcc) return "High G Acceleration";

                return "";
            })(),
            fontFamily: "Inter",
            fontSize: 21,
            fontWeight: 500,
            color: "#000000",
            padding: 4
        },
        axisX: {
            title: "Time (S)",
            suffix: "",
            gridThickness: 1,
            gridColor: "#dbdbdb",
            titleFontSize: 22,
            labelFontSize: 12,
        },
        axisY: {
            title: visibleGraphs.acc
                ? "Accel (m/s^2)"
                : visibleGraphs.hGAcc
                    ? "Accel (g)"
                    : visibleGraphs.height && subVisibleGraphs.height
                        ? "Altitude (m)"
                        : "",
            titleFontFamily: "Inter",
            titleFontSize: 22,
            labelFontSize: 12,
            gridThickness: 1,
            gridColor: "#dbdbdb",
        },
        axisY2: {
            title: visibleGraphs.height && visibleDatasets.x ? "Pressure (Pa)" : "",
            titleFontFamily: "Inter",
            titleFontSize: 22,
            labelFontSize: 12,
            gridThickness: 1,
            gridColor: "#dbdbdb",

        },
        data: [
            {
                type: "spline",
                toolTipContent: `{x} sec: {y} ${visibleGraphs.acc
                    ? "m/s^2"
                    : visibleGraphs.height
                        ? "pa"
                        : visibleGraphs.hGAcc
                            ? "g"
                            : ""
                    }`,
                dataPoints: visibleGraphs.acc
                    ? accx
                    : visibleGraphs.height
                        ? press
                        : visibleGraphs.hGAcc
                            ? hgx
                            : [],
                visible: visibleDatasets.x,
                name: visibleGraphs.acc
                    ? "x"
                    : visibleGraphs.height
                        ? "pressure"
                        : visibleGraphs.hGAcc
                            ? "x"
                            : "",
                axisYType: visibleGraphs.height ? "secondary" : "primary",
            },
            {
                type: "spline",
                toolTipContent: `{x} sec: {y} ${visibleGraphs.acc ? "m/s^2" : visibleGraphs.hGAcc ? "g" : ""
                    }`,
                dataPoints: visibleGraphs.acc
                    ? accy
                    : visibleGraphs.hGAcc
                        ? hgy
                        : [],
                visible: visibleDatasets.y,
                name: "y",
            },
            {
                type: "spline",
                toolTipContent: `{x} sec: {y} ${visibleGraphs.acc ? "m/s^2" : visibleGraphs.hGAcc ? "g" : ""
                    }`,
                dataPoints: visibleGraphs.acc
                    ? accz
                    : visibleGraphs.hGAcc
                        ? hgz
                        : [],
                visible: visibleDatasets.z,
                name: "z",
            },
            {
                type: "spline",
                toolTipContent: "{x} sec: {y} m/s^2",
                dataPoints: acceleration,
                visible: visibleGraphs.acc && subVisibleGraphs.acc,
                name: "Accel. Magnitude",

            },
            {
                type: "spline",
                toolTipContent: "{x} sec: {y} m",
                dataPoints: height,
                visible: visibleGraphs.height && subVisibleGraphs.height,
                name: "altitude",

            },
            {
                type: "spline",
                toolTipContent: "{x} sec: {y} g",
                dataPoints: hGAcc,
                visible: visibleGraphs.hGAcc && subVisibleGraphs.hGAcc,
                name: "high g magnitude",
            },
        ],
    }), [
        visibleGraphs,
        visibleDatasets,
        subVisibleGraphs,
        accx,
        accy,
        accz,
        press,
        hgx,
        hgy,
        hgz,
        acceleration,
        height,
        hGAcc,
    ]);

    const chartKey = useMemo(() => Date.now(), [chartOptions]);

    useEffect(() => {
        if (chartRef.current?.chart) {
            chartRef.current.chart.destroy();
        }
    }, []);

    useEffect(() => {
        chartRef.current?.chart.render();
    }, [chartOptions]);

    useEffect(() => {
        const _cookie = getCookie("recoil-persist");

        if (!_cookie) {
            logoutHandler();
        } else {
            const user = JSON.parse(_cookie)["KT_app"];
            onGetGraphDetails(user);
        }
    }, []);

    const handleExport = () => {
        if (chartRef.current) {
            chartRef.current.exportChart({ format: "csv" });
        }
    };

    return (
        <div style={{ height: '100%', display: 'flex', gap: 10, flexDirection: 'column' }} >
            <NavBar />
            <Box sx={{ weight: '100%', flex: 1, mb: 4 }}>
                <Paper sx={{ height: '100%', padding: 2, display: 'flex', flexDirection: 'column' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center', // Vertically align content
                            justifyContent: 'space-between', // Space out Breadcrumb and Toolbar
                            gap: '16px', // Optional: Adjust spacing between components
                        }}
                    >
                        {/* Breadcrumb Component */}
                        <Breadcrumb breadcrumbs={breadcrumbs} />

                        {/* Toolbar Component */}
                        <Toolbar title="download graph csv" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <IconButton onClick={downloadCSV} style={{ padding: 0 }}>
                                <FileDownloadIcon color='primary' />
                            </IconButton>
                        </Toolbar>
                    </div>
                    <hr />
                    {loading ?
                        <Paper sx={{
                            height: "100%", mb: 2, backgroundColor: 'transparent', border: 'none', boxShadow: 'none', display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            <CircularProgress />
                        </Paper>
                        :
                        <Box display="flex" flexDirection='column' flex={1}>
                            {/* CONTAINER FOR DISPLAY OTHER DATA */}
                            <Box display='flex' justifyContent='space-between'>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                        <Typography style={{ fontWeight: 500, fontSize: 22, fontFamily: 'Inter', lineHeight: '26.63px' }}>Value of interest</Typography>
                                        <div style={{ display: 'flex', flexDirection: 'row', gap: 20, flexWrap: 'wrap' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                                <Typography style={{ fontWeight: 500, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>Decent speed : </Typography>
                                                <span style={{ fontWeight: 400, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>{deviceInfo?.valuesOfInterest?.["Descent Speed"] ? formatValueWithUnit(deviceInfo?.valuesOfInterest?.["Descent Speed"]) : '--'}</span>
                                            </div>
                                            <div style={{ width: '1px', backgroundColor: '#0000004F', height: '19.36px' }}></div>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>

                                                <Typography style={{ fontWeight: 500, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>Top speed : </Typography>
                                                <span style={{ fontWeight: 400, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}> {deviceInfo?.valuesOfInterest?.["Max Speed"] ? formatValueWithUnit(deviceInfo?.valuesOfInterest?.["Max Speed"]) : '--'}</span>
                                            </div>
                                            <div style={{ width: '1px', backgroundColor: '#0000004F', height: '19.36px' }}></div>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                                <Typography style={{ fontWeight: 500, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>Total flight time :</Typography>
                                                <span style={{ fontWeight: 400, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>  {deviceInfo?.valuesOfInterest?.["Flight Time"] ? formatValueWithUnit(deviceInfo?.valuesOfInterest?.["Flight Time"]) : '--'} </span>
                                            </div>
                                            <div style={{ width: '1px', backgroundColor: '#0000004F', height: '19.36px' }}></div>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                                <Typography style={{ fontWeight: 500, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>Apogee altitude : </Typography>
                                                <span style={{ fontWeight: 400, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}> {deviceInfo?.valuesOfInterest?.["Apogee"] ? formatValueWithUnit(deviceInfo?.valuesOfInterest?.["Apogee"]) : '--'}</span>
                                            </div>
                                            <div style={{ width: '1px', backgroundColor: '#0000004F', height: '19.36px' }}></div>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>

                                                <Typography style={{ fontWeight: 500, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}>Apogee time :</Typography>
                                                <span style={{ fontWeight: 400, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}> {deviceInfo?.valuesOfInterest?.["Apogee Time"] ? formatValueWithUnit(deviceInfo?.valuesOfInterest?.["Apogee Time"]) : '--'}</span>
                                            </div>
                                            <div style={{ width: '1px', backgroundColor: '#0000004F', height: '19.36px' }}></div>
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                                <Typography style={{
                                                    fontWeight: 500, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px', lineHeight: '19.36px'
                                                }}>Coast time : </Typography>
                                                <span style={{ fontWeight: 400, fontSize: 16, fontFamily: 'Inter', lineHeight: '19.36px' }}> {deviceInfo?.valuesOfInterest?.["coastTime"] ? formatValueWithUnit(deviceInfo?.valuesOfInterest?.["coastTime"]) : '--'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Box display="flex" flexDirection='column' gap={1}>
                                    {/* DROP DOWN TO SELECT GRAPH DATA */}
                                    <FormControl sx={{ minWidth: 120 }} size="small">
                                        <InputLabel id="demo-select-small-label">Graph's</InputLabel>
                                        <Select
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={graphs}
                                            label="Graph's"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="acc">Acceleration</MenuItem>
                                            <MenuItem value="alti">Altitude</MenuItem>
                                            <MenuItem value="highGAcc">High G Acceleration</MenuItem>
                                        </Select>
                                    </FormControl>
                                    .
                                    <Box display='flex' gap={1} marginBottom={-2}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={visibleDatasets.x}
                                                onChange={() => toggleDatasetVisibility("x")}
                                                style={{ marginRight: '6px' }}
                                            />
                                            {visibleGraphs.height ? "Pressure" : "x-axis"}
                                        </label>
                                        {!visibleGraphs.height && <label>
                                            <input
                                                type="checkbox"
                                                checked={visibleDatasets.y}
                                                onChange={() => toggleDatasetVisibility("y")}
                                                style={{ marginRight: '6px' }}
                                            />
                                            y-axis
                                        </label>}
                                        {!visibleGraphs.height && <label>
                                            <input
                                                type="checkbox"
                                                checked={visibleDatasets.z}
                                                onChange={() => toggleDatasetVisibility("z")}
                                                style={{ marginRight: '6px' }}
                                            />
                                            z-axis
                                        </label>}
                                    </Box>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={(visibleGraphs.acc && subVisibleGraphs.acc) || (visibleGraphs.height && subVisibleGraphs.height) || (visibleGraphs.hGAcc && subVisibleGraphs.hGAcc)}
                                            onChange={() => setSubVisibleGraphs({
                                                acc: !subVisibleGraphs.acc,
                                                height: !subVisibleGraphs.height,
                                                hGAcc: !subVisibleGraphs.hGAcc,
                                            })}
                                            style={{ marginRight: '6px' }}
                                        />
                                        {visibleGraphs.acc ? "Accel. Magnitude" : visibleGraphs.height ? "Altitude" : visibleGraphs.hGAcc ? "High G Magnitude" : ""}
                                    </label>
                                </Box>
                            </Box>
                            {/* CONTAINER FOR DISPLAY GRAPHDATA */}
                            <Box style={{ display: 'flex', flexDirection: 'column' }} flex={1}>
                                <CanvasJSChart key={chartKey} options={chartOptions} chartRef={chartRef} />;
                                {/* <CanvasJSCSVExport chartRef={chartRef} chartOptions={chartOptions} /> */}

                            </Box>
                        </Box>
                    }
                </Paper>
            </Box>
        </div >
    )
}
